export class BankAccountHelpConst {
    public static headerTable = [
        { field: 'swift', title: 'Código BIC/swift', cell: (row) => `${row.swift}`, class: (row) => `` },
        { field: 'bank', title: 'Banco', cell: (row) => `${row.bank}`, class: (row) => ``}
    ];
}

export class EntranceHelpConst {
    public static headerTable = [
        { field: 'account', title: 'Cuenta contable', cell: (row) => `${row.account}`, class: (row) => `` },
        { field: 'description', title: 'Explicación', cell: (row) => `${row.description}`, class: (row) => ``}
    ];
}

export class ExpenseHelpConst {
    public static headerTable = [
        { field: 'account', title: 'Cuenta contable', cell: (row) => `${row.account}`, class: (row) => `` },
        { field: 'description', title: 'Explicación', cell: (row) => `${row.description}`, class: (row) => ``}
    ];
}